// @ts-ignore
import { PASSPORT_HOST } from '@yandex-int/k-common/constants';
import get from 'lodash/get';

export const getPassportHost = (): string =>
    typeof window === 'undefined' ? PASSPORT_HOST : get(window, '_data.config.passport.host');
